import React, { Component } from 'react'

export class Nosotros_Porque extends Component {
    render() {
        return (
            <div style={{padding: '3% 6%'}} >

                <h3 className="inicio-title">¿Por qué somos una mutual?</h3>
                <p>
                Las mutuales formamos parte del sistema de seguridad social como entidades sin fines de lucro que prestamos diferentes servicios a nuestros asociados.<br/>
                </p>
                <p>
                La particularidad de las entidades sin fines de lucro es que tienen como única meta capitalizar los esfuerzos que realiza en beneficio de sus miembros.<br/>
                </p>
                <p>
                Nosotros colaboramos brindando protección ante accidentes de trabajo y enfermedades laborales, de acuerdo con las normas vigentes para asociaciones sindicales de trabajadores.<br/>
                </p>
                <p>                    
                Somos una ART constituida por la Unión Argentina de Trabajadores Rurales y Estibadores (UATRE) que proporciona cobertura al personal dedicado a la producción y el procesamiento de las actividades del sector rural.<br/>
                </p>
               
            </div>
        )
    }
}

export default Nosotros_Porque
